<div class="bv" (keydown)="billentyu($event)">
  <label class="bv-kereso"><span>Keresés:</span>
    <input type="search" [(ngModel)]="kereses" (ngModelChange)="keresValt()" placeholder="sorszám vagy megnevezés" autofocus>
  </label>
  <div class="tabla-wrap bv-lista">
    <table class="n-racs">
      <thead><tr><th style="width:80px">Sorszám</th><th>Megnevezés</th></tr></thead>
      <tbody>
        <tr *ngFor="let s of lathato" [class.kijelolt]="s === kijelolt" (click)="kijelolt = s" (dblclick)="kivalaszt(s)">
          <td><b>{{ s.kod }}</b></td><td class="bv-nev">{{ s.nev }}</td>
        </tr>
      </tbody>
    </table>
    <div class="ures" *ngIf="!betoltes && !lathato.length">
      Nincs ilyen sor. Új sort a Törzsadatok → ÁFA-bevallási sorok képernyőn vehetsz fel.
    </div>
  </div>
  <div class="bv-lab">
    <button type="button" class="ov-gomb fo" [disabled]="!kijelolt" (click)="kivalaszt()"><ion-icon name="checkmark"></ion-icon>Kiválaszt</button>
    <button type="button" class="ov-gomb" (click)="megse.emit()">Mégse</button>
  </div>
</div>
